import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from '../admin-console-activity-reporting/config-item.gql';
import { GetConfigItem } from '../admin-console-activity-reporting/__generated__/GetConfigItem';

export const DISABLE_PERSONAL_DASHBOARDS_KEY = 'enterprise-sub-disable-personal-dashboards';

export function EnterpriseSubPersonalDashboards() {
  const [queryConfigItem] = useCampfireLazyQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM);
  const [disabled, setDisabled] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryConfigItem({ variables: { key: DISABLE_PERSONAL_DASHBOARDS_KEY } }).then((response) =>
      setDisabled(
        response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue ?? false
      )
    );
  }, []);

  const saveConfigItem = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    saveConfigItem
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: DISABLE_PERSONAL_DASHBOARDS_KEY,
          value: !disabled,
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Request failed');
        }
        setDisabled(!disabled);
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      })
      .catch(() => {
        setSnackbar({
          open: true,
          message: 'Unable to update setting',
          variant: 'error',
        });
      });
  };

  return (
    <Box display='flex' alignItems={'center'}>
      <Switch
        checked={disabled === false}
        disabled={disabled === undefined || saveConfigItem.isLoading}
        onChange={onSave}
        color='primary'
        inputProps={{ 'aria-label': 'allow personal dashboards in sub-accounts' }}
      />
      <Box ml={1}>
        <Typography
          style={{
            fontWeight: 500,
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Allow personal dashboards in sub-accounts
        </Typography>
        <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
          {
            'When off, sub-account staff only see the Organisation dashboard. Reaches sub-accounts on creation or when pushed under Push Updates > Organisation settings.'
          }
        </Typography>
      </Box>
    </Box>
  );
}
